import { useState, useRef, useEffect } from 'react';
import { Epoch } from '../types/epochs';

export const useEpochHeights = (epochs: Epoch[]) => {
  const [epochHeights, setEpochHeights] = useState<{ [key: string]: number }>({});
  const epochRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});

  useEffect(() => {
    Object.entries(epochRefs.current).forEach(([title, element]) => {
      if (element) {
        const heightInVw = (element.offsetHeight / window.innerWidth) * 100;
        setEpochHeights(prev => {
          if (prev[title] === heightInVw) return prev;
          return { ...prev, [title]: heightInVw };
        });
      }
    });
  }, []);

  return { epochRefs, epochHeights };
}; 